import { Action, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";
import { getModuleById, editModule } from "../../../../redux/educator/actions";
import { setInitialSteps } from "../../../../redux/shared/actions";
import { StateType } from "../../../../utils/types";
import { selectModuleSubmitLoading } from "../../../../redux/educator/selector";

const mapStateToProps = (state: StateType) => ({
  module: state.educatorModuleReducer.module,
  submitLoading: selectModuleSubmitLoading(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators(
    {
      getModuleById,
      setInitialSteps,
      editModule,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
